import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

import {Box, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {filterVisibleOptionProducts} from '@amblique/king-living/app/utils/customize-selections';
import {getOptionalAddOns} from '@amblique/king-living/app/utils/product-utils';

import AdditionalAddOns from '@amblique/king-living/app/components/product-view/optional-add-ons/additional-add-ons';

/**
 * Optional add-ons block: extra slots + optional `kingGuardSlot` from parent.
 *
 * @param {Object} props
 * @param {Object} props.product - Product object
 * @param {React.ReactNode} [props.kingGuardSlot] - Optional KingGuard slot
 * @param {Function} [props.onAddOnDetailsOpen] - Handler for opening add-on details (desktop only)
 */
const OptionalAddOnsContainer = ({product, kingGuardSlot, onAddOnDetailsOpen}) => {
  const intl = useIntl();
  const styles = useMultiStyleConfig('OptionalAddOns', {});

  const hasAdditionalAddOns = getOptionalAddOns(product).some(
    (v) => filterVisibleOptionProducts(v?.products).length > 0
  );

  const showRoot = hasAdditionalAddOns || kingGuardSlot != null;

  return showRoot ? (
    <Box className="optional-add-ons-container__root" {...styles.root}>
      <Box className="optional-add-ons-container__header" {...styles.header}>
        <Text as="h3" className="optional-add-ons-container__title" {...styles.title}>
          {intl.formatMessage({
            defaultMessage: 'Optional Add-ons',
            id: 'optional_add_ons.container.title',
          })}
        </Text>
      </Box>

      {hasAdditionalAddOns && <AdditionalAddOns product={product} onAddOnDetailsOpen={onAddOnDetailsOpen} />}
      {kingGuardSlot}
    </Box>
  ) : null;
};

OptionalAddOnsContainer.displayName = 'OptionalAddOnsContainer';

OptionalAddOnsContainer.propTypes = {
  product: PropTypes.object.isRequired,
  kingGuardSlot: PropTypes.node,
  onAddOnDetailsOpen: PropTypes.func,
};

export default OptionalAddOnsContainer;
